import { ONE_MINUTE_IN_MS } from '@/lib/constants';

export const INSIGHTS_API_BASE = 'api/v1/insights';
export const INSIGHTS_TIMEOUT_MS = ONE_MINUTE_IN_MS;
